import React, { useState } from "react";
import {
  Dialog,
  useTheme,
  Stack,
  DialogContent,
  Grid,
  Typography,
  Container,
  Box,
} from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { tokens } from "../../theme";
import { useEffect } from "react";

function AddNewCycleDialog({
  open,
  onClose,
  onDialogButtonClick,
  onDialogRemoveButtonClick,
  data,
  selectedRow,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [updatedValue, setUpdatedValue] = useState([]);

  useEffect(() => {
    if (data !== null) {
      setUpdatedValue(data.payoutDatesAuditDetailsList);

      setSelectedTitle(data.commissionCategory);
      setSelectedDescription(data.commissionDescription);
    }

    setDialogOpen(open);
  }, [open, data]);

  const [dialogOpen, setDialogOpen] = useState(open);

  const handleRemove = (e) => {
    // Close the dialog
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogContent>
        <Grid container direction={"column"}>
          <Grid container pb={2}>
            <Grid container justifyContent="center" alignItems="center" item>
              {updatedValue && updatedValue.length > 0 ? (
                <Typography fontWeight={"600"} variant="h5">
                  {selectedTitle}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid container justifyContent="center" alignItems="center" item>
              {updatedValue &&  updatedValue.length > 0 ? (
                <Typography fontWeight={"600"} variant="h5">
                  {selectedDescription}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>

          {updatedValue &&  updatedValue.length > 0 ? (
            <Container>
              {updatedValue && updatedValue.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    //border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "16px",
                  }}
                >
                    <Grid container spacing={2} >
                      <Grid item xs={6}>
                        <Typography variant="body1" fontWeight="bold">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} >
                        <Typography variant="body1" paddingLeft={2}>  {item.updatedValue}</Typography>
                      </Grid>
                    </Grid>
                
                </Box>
              ))}
            </Container>
          ) : (
            ""
          )}

          {/* {updatedValue.length > 0 ? (
            <div>
              {updatedValue.map((item) => (
                <div
                  key={item.id}
                  style={{
                    margin: "10px",
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                >
                  {Object.entries(item).map(([key, value]) => (
                    <div key={key}>
                      <strong>{key}:</strong> {value}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            ""
          )} */}

          <Stack direction="row" pt={2} spacing={2} justifyContent={"center"}>
            <CustomButton
              btnBG={colors.primary[900]}
              btnColor={colors.grey[100]}
              btnTxt={"CLOSE"}
              btnBorder={"1px solid" + colors.primary[800]}
              onClick={handleRemove}
            ></CustomButton>

            {/* <CustomButton
                  btnBG={colors.primary[100]}
                  btnColor={colors.grey[900]}
                  btnTxt={"SAVE"}
                  btnBorder={"1px solid" + colors.primary[100]}
                  onClick={handleSubmit}
                ></CustomButton> */}
          </Stack>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default AddNewCycleDialog;
